<template>
  <div
    class="sticky top-0 left-0 w-full z-40"
    style="background-color: #5C452B"
  >
    <div class="container flex items-center py-1 pt-3" :class="authenticated ? 'justify-between' : 'justify-center'">
      <h6 class="">
        <h1 class="text-white text-center">
          <img
            src="https://blendpituba.com.br/static/img/blend-pituba.png"
            :alt="datas.enterprise.name"
            class="img-fluid logo-empred max-h-16"
            style="pointer-events: none"
          />
        </h1>
      </h6>
      <div class="dropdown" v-if="authenticated">
          <a href="#" class="d-flex align-items-center text-white text-decoration-none dropdown-toggle"
              id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
              <img src="@/assets/img/user.png" alt="" width="32" height="32" class="rounded-circle me-2" />
              <strong>{{ user?.name }}</strong>
          </a>
          <ul class="dropdown-menu dropdown-menu-dark text-small shadow" id="dropdown-menu"
              aria-labelledby="dropdownUser1">
              <li>
                  <hr class="dropdown-divider" />
                  <span class="dropdown-item cursor-pointer" @click="logout">Sair</span>
              </li>
          </ul>
      </div>
    </div>
  </div>
  <template v-if="!empty">
    <div class="container mt-10">
      <h2 class="text-lg font-light uppercase">
        Acompanhe o progresso da construção
      </h2>
    </div>
    <div class="container my-8">
      <!-- DESKTOP -->
      <div class="d-none d-lg-block relative px-6">
        <button
          class="swiper-button-custom prev"
            @click="prevSlide"
          aria-label="Anterior"
          v-if="allDates.length > 1"
        >
          ‹
        </button>

        <!-- Botão próximo -->
        <button
          class="swiper-button-custom next"
          @click="nextSlide"
          aria-label="Próximo"
          v-if="allDates.length > 1"
        >
          ›
        </button>
        <swiper
          :slidesPerView="'auto'"
          :space-between="5"
          :navigation="false"
          class="swiper-datas"
          @swiper="onSwiper"
          style="--swiper-navigation-color: #b98f47"
        >
          <swiper-slide class="relative group flex gap-1" v-for="data in allDates" :key="data.date">
            <div
            @click="goToDate(data.date)"
            class="date-card"
            :class="{ active: $route.params.data === data.date }">
              {{ data.title }}
            </div>
            <div v-if="authenticated">
            <img  src="@/assets/img/remover.png" title="Remover"
                                                  class="effect-up cursor-pointer group-hover:block" width="24"
                                                  @click.stop.prevent="removeData(data.date)" />
                                                  </div>
          </swiper-slide>
        </swiper>
      </div>

      <!-- MOBILE -->
      <div class="d-lg-none d-flex gap-2 overflow-x-auto px-2 pb-2">
        <div class="flex gap-2 group" v-for="data in allDates"
          :key="data.date">
          <div 
          @click="goToDate(data.date)"
          class="date-card"
          :class="{ active: $route.params.data === data.date }">
            {{ data.title }}
          </div>
          <div v-if="authenticated">
            <img  src="@/assets/img/remover.png" title="Remover"
                                                  class="effect-up cursor-pointer block" width="24"
                                                  @click.stop.prevent="removeData(data.date)" />
                                                  </div>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Cookies from "js-cookie";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import { debounce } from "@/helpers/debounce.js";
import SwiperCore, { Navigation, Pagination, Scrollbar } from "swiper/core";
export default {
  name: "Menu",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    empty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openAccordions: [], // anos abertos
      swiperInstance: null,
    };
  },
  methods: {
    ...mapActions(["setUser", "setAuthenticated"]),
    toggleAccordion(year) {
      if (this.openAccordions.includes(year)) {
        this.openAccordions = this.openAccordions.filter((y) => y !== year);
      } else {
        this.openAccordions = [year];
      }
    },
    onSwiper(swiper) {
      this.swiperInstance = swiper;
    },
    goToDate(date) {
      this.$router.push({ name: "DataFilter", params: { data: date } });
    },
    nextSlide() {
      if (this.swiperInstance) {
        this.swiperInstance.slideNext();
      }
    },
    prevSlide() {
      if (this.swiperInstance) {
        this.swiperInstance.slidePrev();
      }
    },
    expandMenu(e) {
      e.target.classList.add("d-none");
      document.getElementById("menu-expandido").classList.remove("d-none");
    },
    recolheMenu() {
      document.querySelector(".expand-menu").classList.remove("d-none");
      document.getElementById("menu-expandido").classList.add("d-none");
    },
    logout() {
      var token = Cookies.get("_mysapp_token");
      fetch(`${process.env.VUE_APP_ENV_API}${process.env.VUE_APP_ENV_LOGOUT}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      })
        .then((response) => response.json())
        .then(() => {
          Cookies.remove("_mysapp_token");
          this.setAuthenticated(false);
          this.setUser(null);
          document.location.reload();
        })
        .catch((err) => console.error(err));
    },
    async removeData(dateToRemove) {
      // procura título para mensagem de confirmação
      const idxInTitles = this.dataTitles.findIndex(
        (d) => d.date === dateToRemove
      );
      const titleForConfirm =
        idxInTitles !== -1 ? this.dataTitles[idxInTitles].title : dateToRemove;

      if (
        !confirm(
          `Você tem certeza que deseja remover os dados de ${titleForConfirm}?`
        )
      )
        return;

      try {
        var token = Cookies.get("_mysapp_token");

        // encontra o constructionId pelo date
        var constructionIndex =
          this.datas.enterprise.constructionscolumn.findIndex(
            (c) => c.date === dateToRemove
          );
        if (constructionIndex === -1) {
          alert("Não foi possível localizar a obra para remoção.");
          return;
        }
        var constructionId =
          this.datas.enterprise.constructionscolumn[constructionIndex].id;

        const resp = await fetch(
          `${
            process.env.VUE_APP_ENV_API
          }${process.env.VUE_APP_ENV_EMPREENDIMENTO_OBRA_DELETE.replace(
            "{id_enterprise}",
            process.env.VUE_APP_ENV_EMPREENDIMENTOID
          ).replace("{id}", constructionId)}`,
          {
            method: "DELETE",
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        );
        const data = await resp.json();

        if (data.delete == "ok") {
          // remove do dataTitles (localizando pelo date)
          const globalIndex = this.dataTitles.findIndex(
            (d) => d.date === dateToRemove
          );
          if (globalIndex !== -1) {
            this.dataTitles.splice(globalIndex, 1);
          }

          // remove da lista de constructionscolumn
          if (constructionIndex !== -1) {
            this.datas.enterprise.constructionscolumn.splice(
              constructionIndex,
              1
            );
          }

          // calcula a próxima "lastDate" com base nas datas restantes (ordenadas decrescentemente)
          const remainingSorted = this.dataTitles
            .slice()
            .sort((a, b) => b.date.localeCompare(a.date));
          const lastDate = remainingSorted.length
            ? remainingSorted[0].date
            : "0000-00-00";

          if (this.$route.params.data == dateToRemove) {
            this.$router.push(`/${lastDate}`);
          }
        } else {
          alert(
            "Não foi possível atualizar os dados. Tente novamente mais tarde."
          );
          window.location.reload();
        }
      } catch (err) {
        console.error(err);
        alert("Ocorreu um erro ao tentar remover. Veja o console.");
      }
    },
    navigateToDate(direction) {
      if (!this.dataTitles || !this.dataTitles.length) return;

      // Ordena as datas em ordem crescente
      const sortedDates = this.dataTitles.sort((a, b) =>
        a.date.localeCompare(b.date)
      );
      const currentDate = this.$route.params.data;
      const currentIndex = sortedDates.findIndex((d) => d.date === currentDate);

      if (currentIndex === -1) return;

      let targetIndex =
        direction === "next" ? currentIndex + 1 : currentIndex - 1;

      // limita para não sair do array
      if (targetIndex < 0 || targetIndex >= sortedDates.length) return;

      const targetDate = sortedDates[targetIndex].date;
      this.$router.push({ name: "DataFilter", params: { data: targetDate } });
    },
  },
  computed: {
    ...mapGetters(["datas", "dataTitles", "authenticated", "user"]),

    // Agrupa por ano e ORDENA anos e datas em ordem DECRESCENTE
    groupedDates() {
      const groupsMap = {};
      (this.dataTitles || []).forEach((item) => {
        const year = (item.date || "").split("-")[0] || "0000";
        if (!groupsMap[year]) groupsMap[year] = [];
        groupsMap[year].push(item);
      });

      // transforma em array e ordena as datas dentro de cada ano (decrescente)
      const groups = Object.keys(groupsMap).map((year) => {
        return {
          year,
          dates: groupsMap[year]
            .slice()
            .sort((a, b) => b.date.localeCompare(a.date)),
        };
      });

      // ordena os anos de forma decrescente (ex: 2025, 2024, ...)
      groups.sort((a, b) => {
        // compara como número quando possível
        const ay = parseInt(a.year) || 0;
        const by = parseInt(b.year) || 0;
        return by - ay;
      });

      return groups;
    },
    allDates() {
      // Se quiser juntar todos os anos num único array para o Swiper
      return this.groupedDates.flatMap((g) => g.dates);
    },
  },
  mounted() {
    window.addEventListener("date-prev", () => {
      this.navigateToDate("prev");
    });
    window.addEventListener("date-next", () => {
      this.navigateToDate("next");
    });

    this.openAccordions = [new Date().getFullYear().toString()];
  },
  beforeUnmount() {
    window.removeEventListener("date-prev");
    window.removeEventListener("date-next");
  },
};
</script>

<style>
.swiper-datas .swiper-wrapper {
  /* padding-left: 50px;
  padding-right: 50px; */
  padding-top: 10px;
  padding-bottom: 10px;
}
#menu-expandido .dropdown-menu-dark {
  color: #4d4d4d;
  background-color: white;
  border-color: white;
}

#menu-expandido .dropdown-menu-dark .dropdown-item {
  color: #4d4d4d;
}

#menu-expandido .dropdown-item:focus {
  background-color: #e6ebf5 !important;
}

.data-remove {
  position: absolute;
  top: -3px;
  right: -3px;
  display: none;
}

.router-link:hover .data-remove {
  display: block;
}

#panelsStayOpen-collapseOne::-webkit-scrollbar {
  width: 10px;
}

/* Track */
#panelsStayOpen-collapseOne::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
#panelsStayOpen-collapseOne::-webkit-scrollbar-thumb {
  background: white;
}

/* Handle on hover */
#panelsStayOpen-collapseOne::-webkit-scrollbar-thumb:hover {
  background: white;
}

.accordion-c-button {
  width: 100%;
  background: none;
  border: none;
  text-align: left;
  padding: 10px 15px;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.accordion-c-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.accordion-c-body-wrapper {
  overflow: hidden;
}

.accordion-c-body {
  padding: 10px 15px;
}

.arrow {
  transition: transform 0.3s ease;
  display: inline-block;
}

.arrow.rotated {
  transform: rotate(180deg);
}

.open-header {
  background-color: rgba(255, 255, 255, 0.1);
}

/* animação de expandir */
.accordion-enter-active,
.accordion-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
}

.accordion-enter-from,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
}

.accordion-enter-to,
.accordion-leave-from {
  max-height: 500px;
  /* limite arbitrário */
  opacity: 1;
}

.accordion-c-body-link {
  display: flex;
  align-items: center;
  gap: 10px;
}

.accordion-c-body {
  max-height: 65vh;
  overflow-y: auto;
}

.accordion-c-body-link-active {
  font-weight: bold;
}
.date-card {
  background: #f3f3f3;
  color: #5C452B;
  border-radius: 8px;
  padding: 10px 16px;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s;
}

.date-card.active {
  background: #b98f47;
  color: white;
}

.swiper-datas .swiper-slide {
  width: fit-content !important;
}

.date-card:hover {
  transform: scale(1.05);
}

.swiper-button-custom {
  position: absolute;
  top: 50%;
  transform: translateY(-60%);
  z-index: 10;
  background: none;
  color: #b98f47;
  border: none;
  border-radius: 50%;
  /* width: 36px;
  height: 36px; */
  font-size: 52px;
  cursor: pointer;
  transition: background 0.2s;
}

.swiper-button-custom:hover {
  /* background: #0c3a69; */
}

.swiper-button-custom.prev {
  left: -20px;
}

.swiper-button-custom.next {
  right: -20px;
}

.dropdown-menu-dark {
    color: #343a40 !important;
    background-color: #FFFFFF  !important;
    border-color: rgba(0, 0, 0, .15);
}
.dropdown-item{
    color: #343a40 !important;
}
</style>
